import { Injectable } from '@angular/core';

export interface ProfileRouteUser {
  id: number;
  firstName?: string;
  lastName?: string;
}

@Injectable({ providedIn: 'root' })
export class ProfileRouteValidationService {
  isValidProfileRoute(routeUserId: string | null, routeSlug: string | null, user: ProfileRouteUser): boolean {
    if (!routeUserId || !routeSlug) {
      return false;
    }

    const expectedUserId = String(user.id);
    const expectedSlug = this.buildUserSlug(user);

    return routeUserId === expectedUserId && routeSlug === expectedSlug;
  }

  private buildUserSlug(user: ProfileRouteUser): string {
    const fullName = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim();

    const slug = fullName
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    return slug || `user-${user.id}`;
  }
}